import { PublicCardStateController, EnumDto } from '@/api';

export default {
  getCardStateList: async (): Promise<EnumDto[]> => {
    const response = await PublicCardStateController.getAll();
    return response.data?.data ?? [];
  },
};
